import { render } from "./List.vue?vue&type=template&id=0358fe14&scoped=true"
const script = {}

import "./List.vue?vue&type=style&index=0&id=0358fe14&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0358fe14"]])

export default __exports__